import { useEffect, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useAccessUser } from '@/hook/useAccessUser'
import { useDisabledHover } from '@/hook/useDisabledHover'
import CircleSpinner from '@components/shared/CircleSpinner'

import TractsTable from './TractsTable'
import { UpsertTract } from '@components/tract/UpsertTract'

import './Tracts.css'
import SearchInput from '../shared/SearchInput'
import { useSearchParams } from 'react-router-dom'
import { updateSearchParam } from '../shared/utils'
import ConfirmationModal from '../shared/ConfirmationModal'
import { toast } from 'react-toastify'

export const Tracts = () => {
    
    const [showAdd, showHideAdd] = useState(false)
    const [editTract, setEditTract] = useState()
    const [tractToDelete, setTractToDelete] = useState()
    const [tracts, setTracts] = useState([])
    const [filtered, setFiltered] = useState([])
    const [markedDocuments, setMarkedDocuments] = useState([])
    const [loading, setLoading] = useState(false)
    
    const createTract = useAccessUser({ accessType: 'specific_collection', accessName: 'create_tract' })
    const createTractHover = useDisabledHover(!createTract)
    
    const [searchParams, setSearchParams] = useSearchParams({ q: '' })
    
    useEffect(() => {
        setLoading(true)
        
        actions.fetchTracts()
            .then(() => {
                setLoading(false)
            })
        
        return () => {
            actions.emptyTracts()
        }
    }, [])
    
    const allTracts = useWireValue(store.tracts)
    
    const searchValue = query => {
        if (tracts?.length) {
            const search = []
            const copyMarkedDocs = [...markedDocuments]
            
            for (let tract of tracts) {
                if (tract.name.toLowerCase().includes(query.toLowerCase())) {
                    search.push(tract)
                } else {
                    const idx = copyMarkedDocs.indexOf(tract.id)
                    
                    if (idx > -1)
                        copyMarkedDocs.splice(idx, 1)
                }
            }
            
            setMarkedDocuments(copyMarkedDocs)
            setFiltered(search)
        }
    }
    
    useEffect(() => {
        setTracts(allTracts)
        setFiltered(allTracts)
    }, [allTracts])
    
    useEffect(() => searchValue(searchParams.get('q')), [searchParams.get('q')])
    
    return (
        <div>
            <div className="row">
                <div className="col-12 col-xl-12 listCollections">
                    <div className="mb-3 card">
                        <div className="flex gap-4 p-2 items-center">
                            
                            <SearchInput
                                className="grow search"
                                value={searchParams.get('q') || ''}
                                placeholder="Search tracts..."
                                onChange={e => setSearchParams(updateSearchParam('q', e.target.value))} />
                            <div className="flex gap-2">
                                <div {...createTractHover}>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            setEditTract(undefined)
                                            showHideAdd(!showAdd)
                                        }}
                                        disabled={!createTract}>
                                        Create Tract
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="max-h-[calc(100vh-128px)]">
                            {loading && (
                                <div className="flex flex-col justify-center w-full">
                                    <CircleSpinner className="mx-auto mt-20"/>
                                </div>
                            )} 
                            {!loading && <TractsTable
                                tracts={filtered}
                                setEditTract={setEditTract}
                                showHideAdd={showHideAdd}
                                markedDocuments={markedDocuments}
                                setMarkedDocuments={setMarkedDocuments}
                                setTractToDelete={setTractToDelete}
                                createTrackHover={createTractHover} />
                            }
                        </div>
                    </div>
                </div>
            </div>
            
            {showAdd && (
                <UpsertTract
                    id="create-tract"
                    showAdd={showAdd}
                    showHideAdd={showHideAdd}
                    editTract={editTract}
                    onSuccess={actions.fetchTracts}/>
            )}
            
            <ConfirmationModal
                className="DeleteTractConfirmationModal"
                showModal={!!tractToDelete}
                showHideModal={() => setTractToDelete()}
                title="Delete Tract"
                message={`Are you sure you want to delete tract with name ${tractToDelete?.name}`}
                onConfirm={async () => {
                    await actions.deleteTract(tractToDelete?.id)
                    await actions.fetchTracts()
                    toast.success('Tract deleted successfully')
                }} />
        </div>
    )
}
